/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractorPacketLine
 */
export interface ContractorPacketLine {
    /**
     * 
     * @type {string}
     * @memberof ContractorPacketLine
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorPacketLine
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorPacketLine
     */
    rate: number;
}

/**
 * Check if a given object implements the ContractorPacketLine interface.
 */
export function instanceOfContractorPacketLine(value: object): value is ContractorPacketLine {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('rate' in value) || value['rate'] === undefined) return false;
    return true;
}

export function ContractorPacketLineFromJSON(json: any): ContractorPacketLine {
    return ContractorPacketLineFromJSONTyped(json, false);
}

export function ContractorPacketLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractorPacketLine {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'quantity': json['quantity'],
        'rate': json['rate'],
    };
}

export function ContractorPacketLineToJSON(json: any): ContractorPacketLine {
    return ContractorPacketLineToJSONTyped(json, false);
}

export function ContractorPacketLineToJSONTyped(value?: ContractorPacketLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'quantity': value['quantity'],
        'rate': value['rate'],
    };
}

